/*
 *   File : push-notification.js
 *   Author : https://evoqins.com
 *   Description : Create push notification modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React from 'react';

// custom components
import { Icon } from '../Icon';

const ViewPanDetailModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("view-pan-proof-modal-close");
        button.click();
        props.handleClose();
    };

    console.log("props.data", props.data);


    return (
        <div className="modal fade "
            id="view-pan-proof-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="ModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered  modal-dialog-scrollable border-radius-28`}>
                <span id='view-pan-proof-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={` modal-content border-radius-28  border-0 padding-32px-bottom  `}>
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center px-4 pt-4 padding-24px-bottom">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {/* {props.title.split("_").join(" ") || "View details"} */}

                            {props.title
                                ? props.title
                                    .split("_")
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                    .join(" ")
                                : "View details"}
                        </h6>

                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={`modal-body px-0 py-0`}>
                        <div className='px-4'>
                            <div className=' p-3  e-bg-magnolia border-radius-16 e-border-1px-pale-lavender-extra-light '>
                                {/* details */}
                                {/* {Object.keys(props.data).length !== 0 ?
                                    <div className='row g-3'>
                                        {Object.entries(props.data).map(([key, value]) => {
                                            if (!value) return null;

                                            return (
                                                <div key={key} className="col-6">
                                                    <div className='e-font-weight-400 pb-2 e-font-14 line-height-16px e-text-dark-silver text-capitalize'>
                                                        {key.split("_").join(" ")}
                                                    </div>

                                                    <div className='e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>
                                                        {value}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    :
                                    <h6 className='py-5  text-center e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-24px '>
                                        No data found
                                    </h6>
                                } */}


                                {Object.keys(props.data).length !== 0 ? (
                                    <div className="row g-3">

                                        {Object.entries(props.data).map(([key, value]) => {
                                            if (!value) return null;

                                            if (typeof value === "object" && value !== null) {

                                                return (
                                                    <div key={key} className="col-12">
                                                        <div className='e-font-weight-600 e-text-dark-gray pb-2 e-font-16 line-height-18px e-text-dark-silver text-capitalize'>
                                                            {key.split("_").join(" ")}
                                                        </div>

                                                        <div className="row g-3 ms-1">
                                                            {Object.entries(value).map(([childKey, childValue]) => {
                                                                if (childValue === null || childValue === "") return null;

                                                                return (
                                                                    <div key={childKey} className="col-6">
                                                                        <div className='e-font-weight-400 pb-1 e-font-14 line-height-16px e-text-dark-silver text-capitalize'>
                                                                            {childKey.split("_").join(" ")}
                                                                        </div>

                                                                        <div className='e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>
                                                                            {typeof childValue === "boolean"
                                                                                ? childValue ? "Yes" : "No"
                                                                                : childValue}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            }

                                            return (
                                                <div key={key} className="col-6">
                                                    <div className='e-font-weight-400 pb-2 e-font-14 line-height-16px e-text-dark-silver text-capitalize'>
                                                        {key.split("_").join(" ")}
                                                    </div>

                                                    <div className='e-font-weight-600 e-font-14 line-height-16px e-text-dim-black'>
                                                        {typeof value === "boolean" ? (value ? "Yes" : "No") : value}
                                                    </div>
                                                </div>
                                            );
                                        })}

                                    </div>
                                ) : (
                                    <h6 className="py-5 text-center e-text-dark-gray e-alt-font e-font-16 e-font-weight-600 line-height-24px">
                                        No data found
                                    </h6>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ViewPanDetailModal;